import { usePlaceholderImage } from '@/hooks/usePlaceholderImage';

interface PlaceholderImageProps {
  className?: string;
}

/**
 * PlaceholderImage - Shows the branding placeholder image.
 * Used as fallback when posts have no media.
 * Respects whitelabel customization.
 */
export const PlaceholderImage = ({ className = 'w-full h-full' }: PlaceholderImageProps) => {
  const placeholderImage = usePlaceholderImage();
  return <img src={placeholderImage} alt="" className={`object-contain ${className}`} />;
};
